package fr.manyverse.app.domain.validation

import fr.manyverse.app.domain.error.ValidationError

/**
 * Validator for announcement data.
 */
object AnnouncementValidator {
    /**
     * Validates that an announcement has content (text or image).
     */
    fun validateContent(text: String?, imageBytes: ByteArray?): Result<Unit> {
        val hasText = !text.isNullOrBlank()
        val hasImage = imageBytes != null && imageBytes.isNotEmpty()

        if (!hasText && !hasImage) {
            return Result.failure(ValidationError("Message or image is required"))
        }
        return Result.success(Unit)
    }

    /**
     * Validates that at least one participant is selected.
     */
    fun validateParticipants(participants: List<String>): Result<Unit> {
        if (participants.isEmpty()) {
            return Result.failure(ValidationError("At least one participant must be selected"))
        }
        return Result.success(Unit)
    }

    /**
     * Validates announcement for creation.
     */
    fun validateForCreation(
        text: String?,
        imageBytes: ByteArray?,
        participants: List<String>
    ): Result<Unit> {
        validateContent(text, imageBytes).onFailure {
            return Result.failure(it)
        }
        validateParticipants(participants).onFailure {
            return Result.failure(it)
        }
        return Result.success(Unit)
    }
}
